<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
  export default {
    name: 'App',
    data() {
      return {

      }
    },
    mounted() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OperaMini/i.test(navigator.userAgent)) {
              window.location.href='https://kittyhow.com/h5'
      } else {
              console.log('PC',navigator.userAgent)
      }
    },
    computed: {

    },
    beforeMount() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OperaMini/i.test(navigator.userAgent)) {
              window.location.href='https://kittyhow.com/h5'
      } else {
              console.log('PC',navigator.userAgent)
      }
    },
    methods: {

    }
  }
</script>

<style lang="scss">
  /*.v-modal{*/
  /*  display: block;*/
  /*}*/
  .el-button--primary {
    background-color: #ff4d6d !important;
    border-color: #ff4d6d !important;
  }

  .examplesModalDialog {
    position: fixed !important;
    z-index: 8999 !important;
    background: rgba(0, 0, 0, 0.5);
  }

  .examplesModalDialog::v-deep .el-icon-close {
    font-size: 26px !important;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ff4d6d !important;
  }

  /*table边框颜色*/
  .el-table--border:after,
  .el-table--group:after,
  .el-table:before {
    background-color: #F1F1F1 !important;
  }

  .el-table--border,
  .el-table--group {
    border-color: #F1F1F1;
  }

  .el-table td,
    {
    border-bottom: 1px solid #F1F1F1 !important;
  }

  /*.el-table th.is-leaf*/

  .el-table--border th,
  .el-table--border th.gutter:last-of-type {
    border-bottom: 1px solid #F1F1F1 !important;
  }

  .el-table--border td,
  .el-table--border th {
    border-right: 1px solid #F1F1F1 !important;
  }

  /*.has-gutter th, .has-gutter td , .has-gutter .is-leaf{*/
  /*    border: 0px!important;*/
  /*}*/
</style>
